import 'core-js/features/number/is-nan'
import './scripts/BackBlock.js'
import './scripts/HeaderNav.js'
import './scripts/HeroSwiper.js'
import './scripts/PopupCart.js'
